import { Tracker } from "@app/tracking/services/Tracker";

import { analytics } from "./analytics";

/**
 * Tracker configurator
 */
export const tracker = new Tracker({ analytics });
